// extracted by mini-css-extract-plugin
export var subtitle = "_ba-2";
export var title = "_ba-0";
export var titleNoWrap = "_ba-1";